import { openBlock as l, createElementBlock as n, createElementVNode as t } from "vue";
function r(o, e) {
  return l(), n("svg", {
    height: "24",
    width: "24",
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    t("circle", {
      style: { fill: "#0052B4" },
      cx: "256",
      cy: "256",
      r: "256"
    }),
    t("g", null, [
      t("polygon", {
        style: { fill: "#F0F0F0" },
        points: `112.449,155.827 117.975,172.835 135.855,172.835 121.39,183.344 126.915,200.349 \r
		112.449,189.84 97.982,200.349 103.509,183.344 89.043,172.835 106.922,172.835 	`
      }),
      t("polygon", {
        style: { fill: "#F0F0F0" },
        points: `168.101,139.132 173.627,156.139 191.507,156.139 177.042,166.648 182.567,183.653 \r
		168.101,173.144 153.635,183.653 159.161,166.648 144.696,156.139 162.576,156.139 	`
      }),
      t("polygon", {
        style: { fill: "#F0F0F0" },
        points: `223.753,122.436 229.279,139.443 247.159,139.443 232.694,149.953 238.219,166.958 \r
		223.753,156.448 209.287,166.958 214.813,149.953 200.348,139.443 218.228,139.443 	`
      }),
      t("polygon", {
        style: { fill: "#F0F0F0" },
        points: `399.551,155.827 394.025,172.835 376.145,172.835 390.611,183.344 385.085,200.349 \r
		399.551,189.84 414.018,200.349 408.491,183.344 422.957,172.835 405.077,172.835 	`
      }),
      t("polygon", {
        style: { fill: "#F0F0F0" },
        points: `343.899,139.132 338.373,156.139 320.493,156.139 334.959,166.648 329.433,183.653 \r
		343.899,173.144 358.365,183.653 352.839,166.648 367.304,156.139 349.424,156.139 	`
      }),
      t("polygon", {
        style: { fill: "#F0F0F0" },
        points: `288.247,122.436 282.721,139.443 264.841,139.443 279.306,149.953 273.781,166.958 \r
		288.247,156.448 302.713,166.958 297.187,149.953 311.652,139.443 293.772,139.443 	`
      })
    ]),
    t("path", {
      style: { fill: "#FFDA44" },
      d: `M300.522,267.13L256,211.478l-22.261,11.13v22.261l-33.391,22.261h-22.261v28.759\r
	c32.628,13.212,55.652,45.181,55.652,82.546l0,0H256v-22.261l22.261-22.261l22.261,22.261l22.261-22.261v-22.261l22.261-33.391\r
	L300.522,267.13z`
    })
  ]);
}
export {
  r as default
};
